"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basisPointsPrimitiveSchema = exports.PERCENTAGE_TO_BASIS_POINTS_FACTOR = exports.MAX_BASIS_POINTS = void 0;
const zod_1 = require("zod");
exports.MAX_BASIS_POINTS = 10000;
exports.PERCENTAGE_TO_BASIS_POINTS_FACTOR = 100;
exports.basisPointsPrimitiveSchema = zod_1.z.number().int().min(0).max(exports.MAX_BASIS_POINTS);
